import apolloClientFactory from '@narvar/apollo-client';
import { TORAN_GRAPHQL_ENDPOINT } from '../constants/endpoints';

const { client: apolloClient } = apolloClientFactory({
  uri: TORAN_GRAPHQL_ENDPOINT,
});

export default apolloClient;
